import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import toast, { Toaster } from "react-hot-toast";
import { SystemRepository } from "../../repository/AdminDashboard/SystemRepository";
import { Usestatecontext } from "../../context/AdminDashboard/SystemContext";
const stateContext = createContext();
const initialState = {
  edit: {
    costpermonth: "",
    costperSMS: "",
    costperguest: "",
  },
  add: {
    number: "",
  },
};
const SystemModalContext = ({ children }) => {
  const {
    costpermonth,
    costperguest,
    costperSMSpage,
    getsubscription,
    gettabledata,
  } = Usestatecontext();
  const [showEdiModal, setshowEdiModal] = useState(false);
  const [subloaded, setsubloaded] = useState(false);
  const [costmonth, setcostmonth] = useState("");
  const [costSMS, setcostSMS] = useState("");
  const [editcostpermonth, seteditcostpermonth] = useState("");
  const [editperSMS, seteditperSMS] = useState("");
  const [costguest, setcostguest] = useState("");
  const [editperguest, seteditperguest] = useState("");
  const [showADDModal, setshowADDModal] = useState(false);
  const [number, setnumber] = useState("");
  // getdata
  // console.log(costpermonth,costguest)
  const getedit = async () => {
    setsubloaded(true);
    // console.log(initialState.edit);
    const data = await SystemRepository.configPrice(initialState.edit);
    if (data.code === 1) {
      getsubscription();
      toast.success(data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    } else if (data.code == 0) {
      toast.error(data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    }
    setsubloaded(false);
  };
  const getadd = async () => {
    // console.log(initialState.add);
    const data = await SystemRepository.add(initialState.add);
    if (data.code == 1) {
      gettabledata();
      toast.success(data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    } else if (data.code == 0) {
      toast.error(data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    }
  };
  const onEdit = () => {
    setshowEdiModal(true);
    const month = parseInt(costpermonth.replace(/[^\d]/g, ""));
    const sms = parseInt(costperSMSpage.replace(/[^\d]/g, ""));
    const guest = parseInt(costperguest.replace(/[^\d]/g, ""));
    seteditcostpermonth(month.toString());
    seteditperSMS(sms.toString());
    seteditperguest(guest.toString());
    // console.log()
  };
  const handlepricemodal = (event) => {
    const inputValue = event.target.value;
    const number = Number(inputValue.replace(/,/g, ""));
    const formatted = new Intl.NumberFormat().format(number);
    const eventtype = event.currentTarget.id;
    if (eventtype === "month") {
      setcostmonth(formatted);
    } else if (eventtype === "SMS") {
      setcostSMS(formatted);
    } else if (eventtype === "guest") {
      setcostguest(formatted);
    }
  };

  const btnClick = async () => {
    if (
      initialState.edit.costpermonth.length > 0 &&
      initialState.edit.costperSMS.length > 0 &&
      initialState.edit.costperguest.length > 0
    ) {
      setshowEdiModal(false);
      await getedit();
    } else {
      toast.error("مشخصات خود را کامل کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
  };
  const closeEditmodal = () => {
    setshowEdiModal(false);
  };
  const addgranti = () => {
    setshowADDModal(true);
  };
  const closeAddmodal = () => {
    setshowADDModal(false);
  };
  const adddone = async () => {
    if (initialState.add.number.length > 0) {
      setshowADDModal(false);
      await getadd();
    }
  };
  const onchangeInput = (event) => {
    const { id, value } = event.target;
    
    if (id === "number") {
      setnumber(value.trim()); // Assuming setNumber is a state setter function
    }
  };
  initialState.edit.costpermonth = costmonth;
  initialState.edit.costperSMS = costSMS;
  initialState.edit.costperguest = costguest;

  initialState.add.number = number;
  return (
    <stateContext.Provider
      value={{
        onEdit,
        showEdiModal,
        costmonth,
        setcostmonth,
        handlepricemodal,
        closeEditmodal,
        setcostSMS,
        costSMS,
        editcostpermonth,
        costperguest,
        editperSMS,
        costguest,
        setcostguest,
        editperguest,
        addgranti,
        btnClick,
        showADDModal,
        closeAddmodal,
        onchangeInput,
        adddone,
      }}>
      {children}
    </stateContext.Provider>
  );
};
function Usestatemodal() {
  return React.useContext(stateContext);
}
export { Usestatemodal };
export default SystemModalContext;
